import React, { useState, useEffect, useCallback } from "react";

export const ScreenSaver = ({ onExit }) => {
  const [clickCount, setClickCount] = useState(0);

  const handleInteraction = useCallback(() => {
    setClickCount(prev => {
      const next = prev + 1;
      if (next >= 3) onExit();
      return next;
    });
  }, [onExit]);

  useEffect(() => {
    const onKey = () => handleInteraction();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [handleInteraction]);

  return (
    <div
      onClick={handleInteraction}
      className="fixed inset-0 z-[9999] flex items-center justify-center cursor-pointer select-none"
      style={{
        background: "radial-gradient(ellipse at 50% 120%, #0a2a4a 0%, #0c1628 50%, #060d18 100%)",
      }}
      data-testid="screensaver"
    >
      {/* Subtle glow at bottom */}
      <div
        className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[120px] rounded-full blur-[80px] opacity-30"
        style={{ background: "#1a6bb5" }}
      />

      {/* Logo */}
      <div className="flex flex-col items-center gap-3 animate-fade-in">
        <span
          className="text-5xl font-light tracking-[0.5em] text-white"
          style={{ fontFamily: "'Inter', sans-serif", textShadow: "0 0 40px rgba(255,255,255,0.08)" }}
        >
          FONDO
        </span>
        <div className="flex items-center gap-3">
          <div className="w-8 h-px" style={{ background: "#3a5068" }} />
          <span className="text-xs tracking-[0.3em]" style={{ color: "#4a6580" }}>EST. 2016</span>
          <div className="w-8 h-px" style={{ background: "#3a5068" }} />
        </div>
      </div>
    </div>
  );
};
